import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddEconomicactivities, Economicactivities } from '../models/Economicactivities/Economicactivities';


@Injectable({
  providedIn: 'root'
})
export class EconomicactivitiesService {

  constructor(
    private _http: HttpClient
  ) { }

    public getEconomicactivities(EconomicactivitiesId?: number): Observable<Economicactivities[]>{
        return this._http.get<Economicactivities[]>(`${environment.api.url}/Economicactivities?EconomicactivitiesId=${EconomicactivitiesId??''}`);
    }
  
    public deleteEconomicactivities(EconomicactivitiesId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/Economicactivities/${EconomicactivitiesId}`);
    }
  
    public addEconomicactivities(model: AddEconomicactivities): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/Economicactivities`, model);
    }
}
